export const howToFormatPostsText = `

# Simple formatting

Just type your post up, and leave an extra line between paragraphs. QuirkLocal will automatically format your post for you. 

You can paste links into the post, and QuirkLocal will automatically create a link for you, inserting the link syntax as described below.

# Getting Fancy

QuirkLocal uses a lightweight formatting syntax called 'Markdown' that allows you to format plain text into rich text. This supports creating
beautifully formatted long-form content, or just spicing up a short post.

Here are some basic elements. You can copy and paste the examples below into a post to see how they work.

---
**Headings** 

\`\`\`
# Heading
\`\`\`

Start a line with a hash tag, then a space, then the heading test, this creates formatted heading, add more hashes \`#\` for smaller headings.

# Heading 1
## Heading 2
### Heading 3

---
**Emphasis**

\\*Text you want to emphasize\\*

Surrounding text with an asterix on each side creates _italic_ text.

---

**Lists**

\`\`\`
- Item 1
- Item 2
- Item 3
\`\`\`

Creates a bulleted list of items.

\`\`\`
1. Item 1
2. Item 2
3. Item 3
\`\`\`


Creates a numbered list of items.

Example:

- Item 1
- Item 2
- Item 3

---

**Links**

\`\`\`
[Link Label](http://quirklocal.com)
\`\`\`

Creates a link to a website. 

Example:

[Link Label](http://quirklocal.com)

---

**Images**

\`\`\`
![cute dog](https://picsum.photos/id/237/200/300)
\`\`\`


To create an image embed:

![cute dog](https://picsum.photos/id/237/200/300)

---
**Quote Blocks**

\`\`\`
> I think this is the right way to develop this plot of land.
> -*Trustee Kerigan*
\`\`\`

Creates a quote block:

> I think this is the right way to develop this plot of land, 
> and respect the wishes of the community.
> -*Trustee Kerigan*

`;
